module.exports = __webpack_public_path__ + "908e4d2e/img/send-icon.3cfb6275.svg";